import { useEffect } from 'react';

export function useOnClickOutside(
    containerRef: React.MutableRefObject<HTMLElement | null>,
    handler: () => void,
) {
    useEffect(() => {
        function clickedOutside(e: any) {
            if (containerRef.current && !containerRef.current?.contains(e.target)) {
                handler();
            }
        }
        window.addEventListener('click', clickedOutside);
        window.addEventListener('mousedown', clickedOutside);
        return () => {
            window.removeEventListener('click', clickedOutside);
            window.removeEventListener('mousedown', clickedOutside);
        };
    }, [handler, containerRef.current]);
}
